import { colorPalette } from "./constants";

/**
 * Shared style utilities for common UI patterns
 */
export const sharedStyles = {
  // Section Title Styles
  sectionTitle: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
    marginBottom: "24px",
    borderBottom: `3px solid ${colorPalette.sectionTitle}`,
    paddingBottom: "12px",
  },

  // Paragraph/Body Text Styles
  paragraph: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    lineHeight: 1.8,
  },

  // Content Container
  contentContainer: {
    py: 6,
    px: 4,
    minHeight: "50vh",
  },

  // Icon styles for feature cards
  featureIcon: {
    fontSize: "48px",
    color: colorPalette.sectionTitle,
    marginBottom: "16px",
  },

  // Contact item layout
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
  },

  contactIcon: {
    color: colorPalette.white,
    fontSize: "1.5rem",
    opacity: 0.85,
  },

  contactLink: {
    opacity: 0.85,
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.95rem",
    color: colorPalette.white,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  // Card styles
  card: {
    borderRadius: "8px",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    },
  },
};
